import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import { withRouter } from "react-router";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import FormLabel from "@material-ui/core/FormLabel";

import Button from "common/components/CustomButtons/Button.jsx";
import DeviceHub from "@material-ui/icons/DeviceHub";
import EasyOpenInput from "common/components/EasyForm/EasyOpenInput";
import EasyMACaddress from "common/components/EasyForm/EasyMACaddress";

import loadForm from "core-module/hoc/loadForm";
import { addNewID } from "core-module/services/ids/actions";
import store from "store";
import * as api from "core-module/services/api";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import { showAlert } from "../../core-module/services/errorAlert/reducers"
 
const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "left",
    paddingRight: "20px",
    fontSize: "15px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px"
  },
  containerLine: {
    padding: "10px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  },
  firstContainer: {
    marginTop: "50px"
  }
};

const RegistrationForm = props => {
  const { classes } = props;

  const onFinishRegistration = async (bpsid, isStatic, info) => {
    props.setIsLoading(true);

    let endpoint = `user.${props.ids.user}/ipaddr_registermac`;

    if (Number(bpsid) !== 0) {
      endpoint = endpoint + "." + bpsid;
    }

    let payload = {
      static: isStatic,
      mac_address: info.mac_address,
      description: info.description
    };

    const postNLoadResponse = await api.postNload(
      endpoint,
      payload,
      0,
      `user.${props.ids.user}/ipaddr_count`,
      `user.${props.ids.user}/ipaddr_overview`
    );

      if(postNLoadResponse.error){
        props.setIsLoading(false);
        return;
      } 
      props.history.push(props.location.pathname, {});
      store.dispatch(addNewID("user", ""));
      store.dispatch(addNewID("user", props.ids.user));

  };

  let getErrorStatus = "Error"
  const getErrorMesssage = () => {
    return "Some inputs have invalid format."
  }
  
  const formIsInvalid = () => {
    store.dispatch(showAlert(getErrorMesssage())); 
  }

  return (
    <GridContainer justify="center">
      <GridItem xs={12} lg={6}>
        <Card>
          <CardHeader color="primary" icon className={classes.myCardHeader}>
            <CardIcon color="primary">
              <DeviceHub />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> MAC Registration</h4>
          </CardHeader>
          <CardBody>
            <GridContainer className={classes.firstContainer} />
            {"ipAddress" in props.registrationInfo ? (
              <GridContainer
                key="ipaddress"
                className={classes.containerLine}
                alignItems="center"
              >
                <GridItem xs={6}>
                  <FormLabel className={classes.labelHorizontal}>
                    IP address
                  </FormLabel>
                </GridItem>
                <GridItem xs={6}>
                  <h5 className={classes.datainfo}>
                    {props.registrationInfo.ipAddress}
                  </h5>
                </GridItem>
              </GridContainer>
            ) : null}
            {"networkMask" in props.registrationInfo ? (
              <GridContainer
                key="networkMask"
                className={classes.containerLine}
                alignItems="center"
              >
                <GridItem xs={6}>
                  <FormLabel className={classes.labelHorizontal}>
                    Network Mask
                  </FormLabel>
                </GridItem>
                <GridItem xs={6}>
                  <h5 className={classes.datainfo}>
                    {props.registrationInfo.networkMask}
                  </h5>
                </GridItem>
              </GridContainer>
            ) : null}
            {"gateway" in props.registrationInfo ? (
              <GridContainer
                key="gateway"
                className={classes.containerLine}
                alignItems="center"
              >
                <GridItem xs={6}>
                  <FormLabel className={classes.labelHorizontal}>
                    Gateway Address
                  </FormLabel>
                </GridItem>
                <GridItem xs={6}>
                  <h5 className={classes.datainfo}>
                    {props.registrationInfo.gateway}
                  </h5>
                </GridItem>
              </GridContainer>
            ) : null}
            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  IP address Type
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <h5 className={classes.datainfo}>
                  {props.registrationInfo.static ? "Static" : "Dynamic"}
                </h5>
              </GridItem>
            </GridContainer>
            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  MAC Address
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasyMACaddress
                  propName="mac_address"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>
            <GridContainer
              className={classes.containerLine}
              alignItems="center"
            >
              <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                  Description
                </FormLabel>
              </GridItem>
              <GridItem xs={6}>
                <EasyOpenInput
                  propName="description"
                  connectForm={props.connectForm}
                />
              </GridItem>
            </GridContainer>
            <GridContainer className={classes.labelHorizontal}>
              <GridItem xs={12} sm={6}>
                <Button
                  fullWidth
                  onClick={() => {
                    props.connectForm.cancel();
                    props.onCancelRegistration();
                  }}
                  color="primaryRed"
                >
                  Cancel
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6}>
                <Button
                  fullWidth
                  onClick={() =>
                    props.connectForm.isFormValid()
                      ?
                       onFinishRegistration(
                          props.registrationInfo.bpsId,
                          props.registrationInfo.static,
                          props.connectForm.getFormState(),
                        )
                      : formIsInvalid()
                  }
                  color="primaryLightBlue"
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(
  withRouter(
    loadForm("user.session/ipaddr_registermac.props", RegistrationForm)
  )
);
